import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <React.Fragment>
    <path fillOpacity=".3" d="M2 22h20V2z" />
    <path d="M12 12L2 22h10z" />
  </React.Fragment>,
  'SignalCellular1Bar',
);
